/** Choices offered by the "Rows per page" selector. */
export const PAGE_SIZES = [5, 10, 25, 50, 100];

/**
 * Page size of embedded/secondary tables. TablePagination renders nothing
 * at or below this many results: one compact page holds them all.
 */
export const PAGE_SIZE_COMPACT = 5;
